import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SelectedSkuBin from '@cimpress-technology/ff-react-components/lib/SkuSelector/SelectedSkuBin/SelectedSkuBin';
import { css } from 'emotion';
import { SkuInfoShape } from '../createContract/shared/SkuCard/SkuCard';
import { actions as termActions, selectors as termSelectors } from '../../../reducers/terms';
import { connect } from 'react-redux';
import TermPricingGrid from './TermPricingGrid';
import { skuInfoToPriceModelAndSkuRows } from '../../../utilities/generateCsvRowsOverrideFunctions';
import { getRuleSet } from '../../../services/SkuRuleset';

const selectedSkuBinStyle = css`
  position: relative;
  right: 10px;
`;
class ItemSkuPriceDisplay extends Component {
  static defaultProps = {};

  static propTypes = {
    termRevision: PropTypes.object.isRequired,
    items: PropTypes.objectOf(SkuInfoShape.isRequired).isRequired,
    showSkuRulesetNotFoundError: PropTypes.func,
    clearSkuRuleSetNotFoundError: PropTypes.func
  };

  state = {
    selectedSkuInfo: null
  };

  componentDidMount() {
    const preSelectedSku = Object.values(this.props.items)[0];
    this.selectSku(preSelectedSku);
    this.props.fetchPriceModelsForTermItems(this.props.items);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.items !== this.props.items) {
      this.selectSku(Object.values(this.props.items)[0]);
    }
  }

  selectSku = skuInfo => {
    if (skuInfo) {
      getRuleSet(skuInfo.sku)
        .then(skuRuleSets => {
          const authoritativeRuleSet = skuRuleSets.filter(each => each.authoritative);
          if (authoritativeRuleSet) {
            const skuRuleSet = authoritativeRuleSet[0];
            this.setState({ skuRuleSet });
            this.props.clearSkuRuleSetNotFoundError(null, skuInfo);
          } else {
          }
        })
        .catch(error => {
          this.props.showSkuRulesetNotFoundError(error, skuInfo);
        });
    }
    this.setState({ selectedSkuInfo: skuInfo });
  };

  skuInfoToPriceModelAndSkuRows = async skuList => {
    const { items } = this.props;

    return skuInfoToPriceModelAndSkuRows(skuList, items);
  };

  render() {
    const { items, termRevision, getSelectedSkuPriceModelInfo } = this.props;
    const { selectedSkuInfo, skuRuleSet } = this.state;
    const selectedSkuPriceModelInfo =
      selectedSkuInfo &&
      selectedSkuInfo.priceModel &&
      getSelectedSkuPriceModelInfo(selectedSkuInfo.priceModel.id, selectedSkuInfo.priceModel.revisionId);

    const selectedSkuBin = (
      <div className={`col-xs-12 col-md-3 ${selectedSkuBinStyle}`}>
        <SelectedSkuBin
          style={{ height: 700 }}
          skus={items}
          clickable
          isSkuClicked={sku => sku && selectedSkuInfo && sku === selectedSkuInfo.sku}
          onAction={this.selectSku}
          locale={'en'}
          generateCsvRowsOverride={this.skuInfoToPriceModelAndSkuRows}
        />
      </div>
    );

    const pricingGridWrapper = selectedSkuInfo &&
      skuRuleSet && (
        <div className="col-xs-12 col-md-9">
          <TermPricingGrid
            termRevision={termRevision}
            skuInfo={selectedSkuInfo}
            skuRuleSet={skuRuleSet}
            priceModelInfo={selectedSkuPriceModelInfo || selectedSkuInfo.priceModel}
          />
        </div>
      );

    return (
      <div>
        {selectedSkuBin}
        {pricingGridWrapper}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    getSelectedSkuPriceModelInfo: (id, revisionId) => termSelectors.getPriceModel(state, id, revisionId)
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  const { termRevision } = ownProps;
  return {
    fetchPriceModelsForTermItems: items =>
      dispatch(termActions.fetchPriceModelsForTermItems(items, termRevision.termId, termRevision.revisionId)),
    showSkuRulesetNotFoundError: (error, skuInfo) =>
      dispatch(termActions.setSkuRuleSetLoadingStatus(skuInfo, true, error)),
    clearSkuRuleSetNotFoundError: skuInfo => dispatch(termActions.setSkuRuleSetLoadingStatus(skuInfo, false, null))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ItemSkuPriceDisplay);
